import axios from '../../v2/app/services/axiosService';

export default {
  async canCurrentUserImpersonate(targetUserID) { // MLD-7488
    try {
      const {data} = await axios.get(`/api/users/${targetUserID}/can-be-impersonated-by-current-user`);
      return data.can_impersonate;
    } catch (e) {
      return false;
    }
  },
  async getCurrentUser() { // MLD-5518
    const params = { // MLD-7272
      include_teams: false,
    }
    const response = await axios.get(`/api/user`, {params});
    return response.data;
  },
  async getUser(userID) {
    const response = await axios.get(`/api/users/${userID}`);
    return response.data;
  },
  /**
   * Switch a user to a different current team.
   * @param user the user to be switched
   * @param team the target team
   */
  switchUserToTeam(user, team) {
    return axios.post(`/api/users/${user.id}/teams/${team.id}/switch`);
  },
  async addUserToTeams(userID, teamIDs, roleName) { // MLD-7624
    const data = {
      role: roleName,
      team_ids: teamIDs,
    }
    const response = await axios.post(`/api/users/${userID}/teams`, data);
    return response.data;
  },
  async addUserToTeam(userID, teamID, roleName) {
    const response = await axios.post(`/api/users/${userID}/teams/${teamID}`, {role: roleName});
    return response.data;
  },
  async changeTeamRole(user, team, roleName) {
    const response = await axios.put(`/api/users/${user.id}/teams/${team.id}/role`, {role: roleName});
    return response.data;
  },
  async removeUserFromTeam(user, team) {
    const response = await axios.delete(`/api/users/${user.id}/teams/${team.id}`);
    return response.data;
  },
  async getSettings(userID, collection = null) {
    const response = await axios.get(`/api/admin/users/${userID}/settings`, {params: {collection: collection}});
    return response.data;
  },
  async deleteUser(userID) { // MLD-1972
    const response = await axios.delete(`/api/users/${userID}`);
    return response.data;
  },
  async exportUsers(userIDs, includeGroups = false) {
    const form = {
      include_groups: includeGroups, // MLD-2692
      users: userIDs,
    };
    const {data} = await axios.post(`/api/users/export`, form);
    let blob = new Blob([data], {type: 'text/csv'});
    let link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = includeGroups ? `users_with_group_membership.csv` : 'users.csv';
    link.dispatchEvent(new MouseEvent(`click`, {bubbles: true, cancelable: true, view: window}));
    return data;
  },
  async search(form) { // MLD-5149
    const response = await axios.post(`/api/users/search`, form);
    return response.data;
  }
}
